import { useEffect, useMemo } from 'react';

import { useLoanRequestActions } from '../../store/actions/useLoanRequestActions';
import { useLoanRequestSelector } from '../../store/selectors/useLoanRequestSelector';
import { useGetInitLoanRequestForm } from '../../services/queries/useGetInitLoanRequestForm';
import useAuth from '../useAuth';

export const useLoanRequest = () => {
   const { user } = useAuth();
   const actions = useLoanRequestActions();
   const selector = useLoanRequestSelector();
   const query = useGetInitLoanRequestForm({ userId: user?.id! });

   // const dispatch = useDispatch();
   // const { form, totalInvestment, totalCredit } = useSelector(
   //    (state: RootState) => state.LoanRequest
   // );

   // const { mutate, isPending: isLoading, data } = useInitLoanRequest();

   const frequencyOptions = useMemo(
      () =>
         Array.from({ length: 32 }, (_, index) => {
            const value = (index + 1).toString();
            return {
               id: value,
               label: value,
               value: value,
            };
         }),
      []
   );

   const maxValue = useMemo(() => {
      return Math.max(
         Math.round((selector.totalInvestment - selector.totalCredit) * 1.3),
         0
      );
   }, [selector.totalInvestment, selector.totalCredit]);

   const totalInsurance = useMemo(() => {
      const value = Number(selector.form.value) || 0;
      const insuranceRate = Number(query.data?.insurance_rate) || 0;
      const investment = value * 0.05;

      return Math.round(insuranceRate * (value + investment));
   }, [selector.form.value, query.data?.insurance_rate]);

   const totalCommission = useMemo(() => {
      const value = Number(selector.form.value) || 0;
      const commissionRate = Number(query.data?.commission_rate) || 0;
      const investment = value * 0.05;

      return Math.round(commissionRate * (value + investment));
   }, [selector.form.value, query.data?.commission_rate]);

   const RequestedCredit = useMemo(() => {
      const value = Number(selector.form.value) || 0;
      const investment = value * 0.05;

      return value + investment + totalInsurance + totalCommission;
   }, [selector.form.value, totalInsurance, totalCommission]);

   const MonthlyRate = useMemo(() => {
      const investment = Number(query.data?.total_investment) || 0;
      const value = Number(selector.form.value) || 0;

      return investment >= value
         ? query.data?.internal_loan_rate_with_bank || 0
         : query.data?.internal_loan_rate_without_bank || 0;
   }, [query.data?.credit_limit, selector.form.value]);

   const periodRate = useMemo(() => {
      return selector.form.frequency === 'FORTNIGHTLY'
         ? MonthlyRate / 2
         : MonthlyRate;
   }, [MonthlyRate, selector.form.frequency]);

   const totalQuota = useMemo(() => {
      const period: number = Number(selector.form.period) || 0;
      const periodRateValue: number = Number(periodRate) || 0;

      return (
         (RequestedCredit *
            (periodRateValue * (1 + periodRateValue) ** period)) /
         ((1 + periodRateValue) ** period - 1)
      );
   }, [selector.form.period, RequestedCredit, periodRate]);

   useEffect(() => {
      if (query.data) {
         actions.setTotales(
            query.data.total_investment,
            query.data.credit_limit
         );
      }
   }, [query.data]);

   // const updateTotales = (totalInvestment: number, totalCredit: number) => {
   //    dispatch(setTotales({ totalInvestment, totalCredit }));
   // };
   //
   // const updateLoanRequestForm = (form: any) => {
   //    dispatch(setForm(form));
   // };
   //
   // const resetState = () => {
   //    dispatch(setDefault());
   // };
   //
   // useEffect(() => {
   //    if (data) {
   //       updateTotales(data.total_investment, data.credit_limit);
   //    }
   // }, [query.data]);

   // useEffect(() => {
   //    resetState();
   //    mutate();
   // }, []);

   return {
      selector,
      actions,
      query,
      maxValue,
      frequencyOptions,
      totalQuota,
      RequestedCredit,
      totalInsurance,
      totalCommission,
      MonthlyRate,
      periodRate,
      // form,
      // data,
      // totalInvestment,
      // totalCredit,
      // isLoading,
      // banks: data?.banks || [],
      // updateLoanRequestForm,
      // resetState,
   };
};
